import { Helmet } from "react-helmet-async";

function MetaDecorator({ titulo, descripcion, subtitulo }) {
  return (
    <Helmet>
      <title>{titulo}</title>
      <meta name="title" content={subtitulo} />
      <meta name="description" content={descripcion} />
    </Helmet>
  );
}

export default MetaDecorator;
